import { render, staticRenderFns } from "./ServerClock.vue?vue&type=template&id=f2971d00&scoped=true"
import script from "./ServerClock.vue?vue&type=script&lang=js"
export * from "./ServerClock.vue?vue&type=script&lang=js"
import style0 from "./ServerClock.vue?vue&type=style&index=0&id=f2971d00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2971d00",
  null
  
)

export default component.exports